export default __webpack_public_path__ + "static/media/laba-rugi2.46c9bf05.png";